import { render, staticRenderFns } from "./DownloadConfig.vue?vue&type=template&id=3fdaa42d&scoped=true"
import script from "./DownloadConfig.vue?vue&type=script&lang=js"
export * from "./DownloadConfig.vue?vue&type=script&lang=js"
import style0 from "./DownloadConfig.vue?vue&type=style&index=0&id=3fdaa42d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaa42d",
  null
  
)

export default component.exports